import React from 'react';
import PropTypes from 'prop-types';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRights } from 'providers/RightsConsumer';
import memoize from 'memoize-one';
import PlaylistAddCheck from '@mui/icons-material/PlaylistAddCheck';
import { loadPartnerIncomeTypes, updateOfferPartnerIncomeType } from '../actionCreators';
import OfferPartnerIncomeTypeComponent from './OfferPartnerIncomeTypeComponent';
import OfferPartnerIncomeTypeSummary from './OfferPartnerIncomeTypeSummary';
import OfferPartnerIncomeDataContainer from './OfferPartnerIncomeDataContainer';
import { getOfferPartnerIncomeTypes, getIncomeTypesIsLoaded, getIncomeTypesLoading } from '../selectors';
import { CollapseCard } from '@totalsoft/rocket-ui';

class OfferPartnerIncomeTypeContainer extends React.PureComponent {
  state = {
    incomeTypes: this.props.partnerIncomeTypes || []
  };

  componentDidMount() {
    const { actions, documentId, siteId, partnerId, isAssociatedPartner } = this.props;
    actions.loadPartnerIncomeTypes(documentId, siteId, partnerId, isAssociatedPartner);
  }

  componentDidUpdate(prevProps) {
    const { actions, documentId, siteId, partnerId, isAssociatedPartner } = this.props;
    if (this.props.partnerIncomeTypes && prevProps.partnerIncomeTypes !== this.props.partnerIncomeTypes) {
      actions.loadPartnerIncomeTypes(documentId, siteId, partnerId, isAssociatedPartner);
      this.setState({
        incomeTypes: this.props.partnerIncomeTypes
      });
    }
  }

  getSelectedIncomeTypes = memoize(incomeTypes => {
    return incomeTypes ? incomeTypes.filter(x => x.selected) : [];
  });

  onClientIncomeChange = async (incomeType, selected) => {
    const { actions, documentId, siteId, partnerId, isAssociatedPartner } = this.props;
    let partnerIncomeType = {
      documentId,
      siteId,
      partnerId,
      incomeTypeId: incomeType.incomeTypeId,
      selected: selected
    };

    actions.updateOfferPartnerIncomeTypes(partnerIncomeType, isAssociatedPartner);
  };

  visibleData = incomeType => {
    if (incomeType.selected) {
      if (incomeType.fromExternalSource && !this.props.rights.externalIncomeSourceRead) {
        return false;
      }
      if (incomeType.fromExternalSource && !this.props.rights.anafPfaIncomeRead) {
        return false;
      }
      return true;
    } else {
      return false;
    }
  };

  render() {
    const { t, documentId, siteId, partnerId, loadingIncomeTypes, isAssociatedPartner } = this.props;
    const { incomeTypes } = this.state;
    const { incomeDetailsRead } = this.props.rights;

    return (
      <>
        <CollapseCard
          id={'offerPartnerIncomeTypeCard'}
          icon={PlaylistAddCheck}
          title={t('OfferEdit.Client.IncomeType.Title')}
          subheader={<OfferPartnerIncomeTypeSummary incomeTypes={this.getSelectedIncomeTypes(incomeTypes)} />}
          hideSubheaderOnExpand
          toggleOnHeaderClick
        >
          <OfferPartnerIncomeTypeComponent incomeTypes={incomeTypes} loading={loadingIncomeTypes} onChange={this.onClientIncomeChange} />
        </CollapseCard>

        {incomeDetailsRead &&
          incomeTypes.map((a, idx) => {
            return (
              this.visibleData(a) && (
                <OfferPartnerIncomeDataContainer
                  index={idx}
                  key={a.incomeTypeId}
                  title={a.name}
                  incomeTypeId={a.incomeTypeId}
                  isSalary={a.isSalary}
                  documentId={documentId}
                  siteId={siteId}
                  partnerId={partnerId}
                  fromExternalSource={a.fromExternalSource}
                  isAssociatedPartner={isAssociatedPartner}
                />
              )
            );
          })}
      </>
    );
  }
}

OfferPartnerIncomeTypeContainer.propTypes = {
  actions: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  partnerIncomeTypes: PropTypes.array.isRequired,
  isLoaded: PropTypes.bool.isRequired,
  offerHeader: PropTypes.object.isRequired,
  documentId: PropTypes.number.isRequired,
  siteId: PropTypes.number.isRequired,
  partnerId: PropTypes.number.isRequired,
  loadingIncomeTypes: PropTypes.object.isRequired,
  isAssociatedPartner: PropTypes.bool,
  rights: PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps) {
  return {
    partnerIncomeTypes: getOfferPartnerIncomeTypes(state, ownProps.partnerId),
    isLoaded: getIncomeTypesIsLoaded(state, ownProps.partnerId),
    loadingIncomeTypes: getIncomeTypesLoading(state, ownProps.partnerId),
    offerHeader: state.currentOffer.header
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ loadPartnerIncomeTypes, updateOfferPartnerIncomeTypes: updateOfferPartnerIncomeType }, dispatch),
    dispatch
  };
}

export default compose(connect(mapStateToProps, mapDispatchToProps), withTranslation())(withRights(OfferPartnerIncomeTypeContainer));
